<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="content" style="width: 100%;background-color: #FFFFFF;">
              <img src="@/assets/images/storageLoc.png" alt="储位编码规则">
            </div>
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // Author thq
    // Date 2021-04-16 00:58:58

    import emCommonEditMixin from "@/mixin/em/common/edit";

    export default {
        name: "emSppStorageLocEditView",
        mixins: [emCommonEditMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            }
        }
    };
</script>